export const SET_PLOTS_DATA = 'SET_PLOTS_DATA';
export const setPlotsData = (records, count) => ({
    type: SET_PLOTS_DATA,
    payload: { records, count }
});
